import { useSelector } from 'react-redux'
import { CloseIcon } from '../../../assets/icons/Svg'
import { selectClientQrCode, selectCurrentClient } from '../../../features/client/clientSlice'

interface QRCodeProps {
    setOpenQRCodeModal: (value: boolean) => void
}

export default function QrCode({ setOpenQRCodeModal }: QRCodeProps) {

    const urlQRCode = useSelector(selectClientQrCode);

    const handleDownload = () => {
        if (!urlQRCode) return;
        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = urlQRCode;
        link.download = 'QRCode.png'; // default file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-auto mx-5 bg-white rounded-lg shadow px-5 flex'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    QR Code
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={() => {
                                        // setUrlQRCode('')
                                        setOpenQRCodeModal(false)
                                    }}
                                >
                                    <CloseIcon />
                                </button>
                            </div>
                        </div>
                        <div className='w-full'>
                            <img 
                                src={urlQRCode ?? undefined}
                                alt="QR Code" 
                            />
                        </div>
                        <div className='w-full'>
                            <button 
                                onClick={handleDownload}
                                className='flex-1 w-full text-sm px-4 py-1.5 rounded font-medium transition-all bg-cbColor text-white shadow-md'
                            >
                                Download QR Code
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
